var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',{staticClass:"text-center"},[_vm._v(" This site may only be accessed via the Nexus Connect Inbox. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }